module.exports = __webpack_public_path__ + "media/images/leader-2-9f740d3920e43730bbbcaceefd18117f.svg";